var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.919922 9.36012C1.16992 7.52012 3.03991 6.13012 4.84991 6.17012C4.61991 5.11012 4.79992 3.90015 5.35992 2.95015C7.28992 -0.33985 13.83 -0.0598774 14.52 4.11012C16.2 3.88012 17.8399 4.43015 18.6899 5.95015C19.0099 6.51015 19.27 7.33011 19.33 7.97011V8.95015C19.2 9.25015 19.2099 9.61013 19.1299 9.93013C18.5799 11.9901 16.7199 13.4502 14.5499 13.2102C13.5799 13.1002 13.7299 11.9402 14.4699 11.9002C14.6499 11.8902 14.8599 11.9901 15.1199 11.9801C18.8899 11.8301 19.32 5.03011 14.96 5.35011C14.42 5.39011 13.3799 5.92017 13.2399 5.03017C13.1799 4.62017 13.34 4.29013 13.14 3.74013C12.15 1.01013 5.71996 1.26014 6.01996 5.63014C6.05996 6.26014 6.65994 7.39012 5.62994 7.48012C5.16994 7.52012 4.76994 7.38014 4.18994 7.50014C1.45994 8.10014 1.44991 11.8101 4.65991 11.9801C5.19991 12.0101 6.21995 11.6702 6.25995 12.5202C6.30995 13.5902 4.09996 13.2002 3.45996 13.0202C2.06996 12.6402 1.21994 11.6601 0.939941 10.2601C0.969941 9.97015 0.899941 9.64012 0.939941 9.36012H0.919922Z",
    fill: "#666666",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6595 16.3201C11.3895 15.8801 12.1095 15.0101 12.8295 14.6001C13.5995 14.1601 14.2095 14.9801 13.5995 15.6101C12.7595 16.4801 11.3295 17.2201 10.4595 18.1201C10.1295 18.3201 9.96951 18.3201 9.63951 18.1201C8.58951 17.4901 7.51949 16.2101 6.42949 15.5601C5.99949 15.0501 6.41947 14.3201 7.03947 14.4901C7.64947 14.6601 8.78949 16.0001 9.42949 16.3201V8.50012C9.42949 8.37012 9.84947 8.12012 10.0395 8.12012C10.2295 8.12012 10.6495 8.36012 10.6495 8.50012V16.3201H10.6595Z",
    fill: "#666666",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud_download.550a9c9b2d0ecf29e747acd59098f3e1.svg";
export { ForwardRef as ReactComponent };